import { render } from "./VehicleCardMobile.vue?vue&type=template&id=0381408d&scoped=true"
import script from "./VehicleCardMobile.vue?vue&type=script&lang=js"
export * from "./VehicleCardMobile.vue?vue&type=script&lang=js"

import "./VehicleCardMobile.vue?vue&type=style&index=0&id=0381408d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0381408d"]])

export default __exports__